export default "__VITE_ASSET__7af53aca__"